export default "__VITE_ASSET__DRksQPjZ__"